// import React, { useEffect, useState } from "react";
// import {
//   Mail,
//   Phone,
//   Building2,
//   MapPin,
//   Calendar,
//   Users,
//   X,
//   ChevronRight,
//   Search,
//   Filter,
//   UserPlus,
//   Shield,
//   Trash2,
//   Pencil,
//   Check,
// } from "lucide-react";
// import styles from "./Dashboard.module.css";
// import { getOrganizationMembers } from "./api/index";
// const MODULES = [
//   { id: "docs", label: "Փաստաթղթերի կառավարում" },
//   { id: "designCollab", label: "Դիզայնի համագործակցություն" },
//   { id: "fieldMgmt", label: "Դաշտային կառավարում" },
//   { id: "modelCoord", label: "Մոդելի համակարգում" },
//   { id: "costMgmt", label: "Ծախսերի կառավարում" },
// ];

// const ACCESS_LEVELS = [
//   { value: "none", label: "Առանց մուտքի" },
//   { value: "view", label: "Դիտում" },
//   { value: "edit", label: "Խմբագրում" },
// ];

// const ROLE_OPTIONS = [
//   "Architect",
//   "BIM Manager",
//   "Project Manager",
//   "Structural Engineer",
//   "MEP Engineer",
//   "Contractor",
//   "Designer",
//   "Viewer",
// ];

// const defaultAccess = (level = "view") =>
//   MODULES.reduce((acc, m) => ({ ...acc, [m.id]: level }), {});

// const initialMembers = [
//   {
//     id: 1,
//     name: "Արամ Հակոբյան",
//     role: "Ավագ Ճարտարապետ",
//     department: "Ճարտարապետություն",
//     company: "ViewStruct",
//     email: "aram@viewstruct.am",
//     phone: "+374 91 123 456",
//     location: "Երևան, Հայաստան",
//     joinDate: "2022-09-01",
//     status: "online",
//     avatar: "ԱՀ",
//     skills: ["AutoCAD", "Revit", "BIM 360", "3ds Max"],
//     activeProjects: 5,
//     completedProjects: 19,
//     experience: "8 տարի",
//     isAdmin: true,
//     moduleAccess: {
//       docs: "edit",
//       designCollab: "edit",
//       fieldMgmt: "view",
//       modelCoord: "edit",
//       costMgmt: "view",
//     },
//   },
//   {
//     id: 2,
//     name: "Աննա Սարգսյան",
//     role: "BIM Մասնագետ",
//     department: "BIM",
//     company: "ViewStruct",
//     email: "anna@viewstruct.am",
//     phone: "+374 93 456 789",
//     location: "Երևան, Հայաստան",
//     joinDate: "2021-03-15",
//     status: "online",
//     avatar: "ԱՍ",
//     skills: ["Revit", "Navisworks", "BIM 360", "Dynamo"],
//     activeProjects: 3,
//     completedProjects: 24,
//     experience: "10 տարի",
//     isAdmin: true,
//     moduleAccess: {
//       docs: "edit",
//       designCollab: "edit",
//       fieldMgmt: "edit",
//       modelCoord: "edit",
//       costMgmt: "none",
//     },
//   },
//   {
//     id: 3,
//     name: "Գևորգ Պետրոսյան",
//     role: "Կոնստրուկտոր Ինժեներ",
//     department: "Կոնստրուկցիա",
//     company: "ArmBuild LLC",
//     email: "gevorg@armbuild.am",
//     phone: "+374 94 789 012",
//     location: "Գյումրի, Հայաստան",
//     joinDate: "2023-01-10",
//     status: "busy",
//     avatar: "ԳՊ",
//     skills: ["ETABS", "SAP2000", "AutoCAD", "Tekla"],
//     activeProjects: 4,
//     completedProjects: 11,
//     experience: "5 տարի",
//     isAdmin: false,
//     moduleAccess: {
//       docs: "view",
//       designCollab: "none",
//       fieldMgmt: "edit",
//       modelCoord: "view",
//       costMgmt: "none",
//     },
//   },
//   {
//     id: 4,
//     name: "Մարի Ադամյան",
//     role: "Ինտերիեր Դիզայներ",
//     department: "Դիզայն",
//     company: "ViewStruct",
//     email: "mari@viewstruct.am",
//     phone: "+374 98 345 678",
//     location: "Երևան, Հայաստան",
//     joinDate: "2022-06-20",
//     status: "offline",
//     avatar: "ՄԱ",
//     skills: ["3ds Max", "V-Ray", "SketchUp", "Lumion"],
//     activeProjects: 2,
//     completedProjects: 15,
//     experience: "6 տարի",
//     isAdmin: false,
//     moduleAccess: {
//       docs: "view",
//       designCollab: "edit",
//       fieldMgmt: "none",
//       modelCoord: "none",
//       costMgmt: "none",
//     },
//   },
//   {
//     id: 5,
//     name: "Դավիթ Մկրտչյան",
//     role: "Մեխանիկական Ինժեներ",
//     department: "Մեխանիկա",
//     company: "MetroDesign",
//     email: "davit@metrodesign.am",
//     phone: "+374 77 567 890",
//     location: "Երևան, Հայաստան",
//     joinDate: "2020-11-05",
//     status: "online",
//     avatar: "ԴՄ",
//     skills: ["AutoCAD MEP", "Revit MEP", "Dialux", "HydraCAD"],
//     activeProjects: 6,
//     completedProjects: 32,
//     experience: "12 տարի",
//     isAdmin: false,
//     moduleAccess: {
//       docs: "view",
//       designCollab: "view",
//       fieldMgmt: "edit",
//       modelCoord: "edit",
//       costMgmt: "view",
//     },
//   },
//   {
//     id: 6,
//     name: "Լուսինե Վարդանյան",
//     role: "Նախագծի Ճարտարապետ",
//     department: "Ճարտարապետություն",
//     company: "ViewStruct",
//     email: "lusine@viewstruct.am",
//     phone: "+374 95 234 567",
//     location: "Վանաձոր, Հայաստան",
//     joinDate: "2023-05-12",
//     status: "online",
//     avatar: "ԼՎ",
//     skills: ["AutoCAD", "Civil 3D", "Revit", "Navisworks"],
//     activeProjects: 3,
//     completedProjects: 8,
//     experience: "3 տարի",
//     isAdmin: false,
//     moduleAccess: {
//       docs: "view",
//       designCollab: "view",
//       fieldMgmt: "none",
//       modelCoord: "view",
//       costMgmt: "none",
//     },
//   },
//   {
//     id: 7,
//     name: "Հայկ Սահակյան",
//     role: "IT Մասնագետ",
//     department: "IT",
//     company: "ViewStruct",
//     email: "hayk@viewstruct.am",
//     phone: "+374 96 890 123",
//     location: "Երևան, Հայաստան",
//     joinDate: "2021-08-01",
//     status: "busy",
//     avatar: "ՀՍ",
//     skills: ["Python", "JavaScript", "BIM API", "Cloud"],
//     activeProjects: 4,
//     completedProjects: 20,
//     experience: "7 տարի",
//     isAdmin: true,
//     moduleAccess: {
//       docs: "edit",
//       designCollab: "view",
//       fieldMgmt: "view",
//       modelCoord: "view",
//       costMgmt: "edit",
//     },
//   },
// ];

// const statusLabels = {
//   online: "Առցանց",
//   offline: "Անցանց",
//   busy: "Զբաղված",
//   pending: "Հրավիրված",
// };

// const accessLabel = (value) =>
//   ACCESS_LEVELS.find((a) => a.value === value)?.label ?? "Առանց մուտքի";

// const getInitials = (nameOrEmail) => {
//   const base = nameOrEmail.includes("@")
//     ? nameOrEmail.split("@")[0]
//     : nameOrEmail;
//   const parts = base.trim().split(/\s+/);
//   return (
//     parts
//       .slice(0, 2)
//       .map((p) => p[0]?.toUpperCase())
//       .join("") || "??"
//   );
// };

// const emptyForm = {
//   name: "",
//   email: "",
//   company: "",
//   role: ROLE_OPTIONS[0],
//   moduleAccess: defaultAccess("view"),
// };

// const Dashboard = () => {
//   // const [members, setMembers] = useState(initialMembers);
//   const [members, setMembers] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [loadError, setLoadError] = useState("");

//   const [selectedId, setSelectedId] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filterDept, setFilterDept] = useState("all");
//   const [isAddOpen, setIsAddOpen] = useState(false);
//   const [form, setForm] = useState(emptyForm);
//   const [formError, setFormError] = useState("");
//   const [isEditingAccess, setIsEditingAccess] = useState(false);
//   const [editAccess, setEditAccess] = useState(null);
//   const [confirmRemove, setConfirmRemove] = useState(false);
//   const getTextValue = (value, fallback = "—") => {
//     if (typeof value === "string" || typeof value === "number") {
//       return value;
//     }

//     if (value && typeof value === "object") {
//       return value.name ?? value.title ?? value.description ?? fallback;
//     }

//     return fallback;
//   };
//   useEffect(() => {
//     let isMounted = true;

//     const fetchMembers = async () => {
//       try {
//         setIsLoading(true);
//         setLoadError("");

//         const response = await getOrganizationMembers((error) => {
//           if (isMounted) {
//             setLoadError(error.message);
//           }
//         });

//         if (!isMounted || !response) return;

//         // Աջակցում ենք մի քանի տարածված response կառուցվածքների։
//         const membersData = Array.isArray(response)
//           ? response
//           : (response.members ??
//             response.items ??
//             response.results ??
//             response.data);

//         if (!Array.isArray(membersData)) {
//           console.error("Unexpected members API response:", response);
//           setLoadError("Սերվերի պատասխանի ձևաչափը սխալ է։");
//           return;
//         }

//         setMembers(
//           membersData.map((member) => {
//             const name =
//               member.name ||
//               member.full_name ||
//               member.fullName ||
//               member.email?.split("@")[0] ||
//               "Անդամ";

//             // return {
//             //   ...member,

//             //   // API-ի տվյալները հարմարեցնում ենք UI-ին։
//             //   id: member.id ?? member.user_id ?? member.userId,
//             //   name,
//             //   email: member.email ?? "",
//             //   role: member.role ?? member.position ?? "Անդամ",
//             //   department: member.department ?? member.role ?? "—",
//             //   company: member.company ?? member.organization_name ?? "—",
//             //   phone: member.phone ?? "—",
//             //   location: member.location ?? "—",
//             //   joinDate:
//             //     member.joinDate ?? member.join_date ?? member.created_at ?? "—",
//             //   status: member.status ?? "offline",
//             //   avatar: getInitials(name),
//             //   skills: member.skills ?? [],
//             //   activeProjects: member.activeProjects ?? 0,
//             //   completedProjects: member.completedProjects ?? 0,
//             //   experience: member.experience ?? "—",
//             //   isAdmin:
//             //     member.isAdmin ??
//             //     member.is_admin ??
//             //     member.is_admin_of_organization ??
//             //     false,

//             //   // Եթե API-ն դեռ չի վերադարձնում այս տվյալները,
//             //   // պահպանում ենք UI-ի համար անվտանգ լռելյայն արժեքները։
//             //   moduleAccess: {
//             //     ...defaultAccess("none"),
//             //     ...(member.moduleAccess ?? member.module_access ?? {}),
//             //   },
//             // };
//             return {
//               ...member,
//               id: member.id ?? member.user_id ?? member.userId,
//               name: getTextValue(
//                 member.name ??
//                   member.full_name ??
//                   member.fullName ??
//                   member.email?.split("@")[0],
//                 "Անդամ",
//               ),
//               email: getTextValue(member.email, ""),
//               role: getTextValue(member.role ?? member.position),
//               department: getTextValue(member.department),
//               company: getTextValue(member.company ?? member.organization_name),
//               phone: getTextValue(member.phone),
//               location: getTextValue(member.location),
//               joinDate: getTextValue(
//                 member.joinDate ?? member.join_date ?? member.created_at,
//               ),
//               status: getTextValue(member.status, "offline"),
//               avatar: getInitials(
//                 getTextValue(
//                   member.name ?? member.full_name ?? member.fullName,
//                   "Անդամ",
//                 ),
//               ),
//               skills: Array.isArray(member.skills) ? member.skills : [],
//               activeProjects: member.activeProjects ?? 0,
//               completedProjects: member.completedProjects ?? 0,
//               experience: getTextValue(member.experience),
//               isAdmin: member.isAdmin ?? member.is_admin ?? false,
//               moduleAccess: {
//                 ...defaultAccess("none"),
//                 ...(member.moduleAccess ?? member.module_access ?? {}),
//               },
//             };
//           }),
//         );
//       } catch (error) {
//         if (isMounted) {
//           setLoadError(
//             error.response?.data?.detail ||
//               error.response?.data?.message ||
//               "Չհաջողվեց բեռնել կազմակերպության անդամներին։",
//           );
//         }
//       } finally {
//         if (isMounted) {
//           setIsLoading(false);
//         }
//       }
//     };

//     fetchMembers();

//     return () => {
//       isMounted = false;
//     };
//   }, []);

//   const selectedMember = members.find((m) => m.id === selectedId) || null;

//   const departments = [
//     "all",
//     ...Array.from(new Set(members.map((m) => m.department))),
//   ];

//   const filtered = members.filter((m) => {
//     const q = searchQuery.toLowerCase();
//     const matchSearch =
//       m.name.toLowerCase().includes(q) ||
//       m.role.toLowerCase().includes(q) ||
//       m.email.toLowerCase().includes(q);
//     const matchDept = filterDept === "all" || m.department === filterDept;
//     return matchSearch && matchDept;
//   });

//   const openAddModal = () => {
//     setForm(emptyForm);
//     setFormError("");
//     setIsAddOpen(true);
//   };

//   const closeAddModal = () => setIsAddOpen(false);

//   const updateFormModule = (moduleId, value) => {
//     setForm((f) => ({
//       ...f,
//       moduleAccess: { ...f.moduleAccess, [moduleId]: value },
//     }));
//   };

//   const handleAddMember = (e) => {
//     e.preventDefault();
//     if (!form.email.trim() || !form.email.includes("@")) {
//       setFormError("Խնդրում ենք մուտքագրել վավեր էլ. հասցե");
//       return;
//     }
//     if (!form.company.trim()) {
//       setFormError("Խնդրում ենք նշել ընկերությունը");
//       return;
//     }
//     const nextId = Math.max(0, ...members.map((m) => m.id)) + 1;
//     const displayName = form.name.trim() || form.email.split("@")[0];
//     const newMember = {
//       id: nextId,
//       name: displayName,
//       role: form.role,
//       department: form.role,
//       company: form.company.trim(),
//       email: form.email.trim(),
//       phone: "—",
//       location: "—",
//       joinDate: new Date().toISOString().slice(0, 10),
//       status: "pending",
//       avatar: getInitials(displayName),
//       skills: [],
//       activeProjects: 0,
//       completedProjects: 0,
//       experience: "—",
//       isAdmin: false,
//       moduleAccess: form.moduleAccess,
//     };
//     setMembers((prev) => [newMember, ...prev]);
//     setIsAddOpen(false);
//   };

//   const startEditAccess = () => {
//     setEditAccess({ ...selectedMember.moduleAccess });
//     setIsEditingAccess(true);
//   };

//   const saveEditAccess = () => {
//     setMembers((prev) =>
//       prev.map((m) =>
//         m.id === selectedMember.id ? { ...m, moduleAccess: editAccess } : m,
//       ),
//     );
//     setIsEditingAccess(false);
//   };

//   const cancelEditAccess = () => setIsEditingAccess(false);

//   const removeMember = () => {
//     setMembers((prev) => prev.filter((m) => m.id !== selectedMember.id));
//     setSelectedId(null);
//     setConfirmRemove(false);
//   };

//   return (
//     <div className={styles.container}>
//       <div className={styles.content}>
//         {/* Team List */}
//         <div className={styles.listCard}>
//           <div className={styles.listHeader}>
//             <div className={styles.listHeaderLeft}>
//               <h2 className={styles.listTitle}>
//                 <Users size={20} />
//                 Անդամներ
//               </h2>
//               <span className={styles.listCount}>{filtered.length}</span>
//             </div>
//             <div className={styles.toolbar}>
//               <div className={styles.searchBox}>
//                 <Search size={16} />
//                 <input
//                   type="text"
//                   placeholder="Փնտրել..."
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   className={styles.searchInput}
//                 />
//               </div>
//               <div className={styles.filterBox}>
//                 <Filter size={14} />
//                 <select
//                   value={filterDept}
//                   onChange={(e) => setFilterDept(e.target.value)}
//                   className={styles.filterSelect}
//                 >
//                   {departments.map((d) => (
//                     <option key={d} value={d}>
//                       {d === "all" ? "Բոլորը" : d}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <button className={styles.addBtn} onClick={openAddModal}>
//                 <UserPlus size={16} />
//                 Ավելացնել անդամ
//               </button>
//             </div>
//           </div>

//           <div className={styles.teamList}>
//             {isLoading && (
//               <div className={styles.emptyList}>Անդամները բեռնվում են...</div>
//             )}
//             {!isLoading && loadError && (
//               <div className={styles.emptyList}>{loadError}</div>
//             )}
//             {!isLoading && !loadError && filtered.length === 0 && (
//               <div className={styles.emptyList}>Անդամներ չեն գտնվել</div>
//             )}

//             {!isLoading &&
//               !loadError &&
//               filtered.map((member) => (
//                 <div
//                   key={member.id}
//                   className={`${styles.memberRow} ${selectedId === member.id ? styles.memberRowActive : ""}`}
//                   onClick={() => {
//                     setSelectedId(member.id);
//                     setIsEditingAccess(false);
//                     setConfirmRemove(false);
//                   }}
//                 >
//                   <div className={styles.memberAvatar}>
//                     {member.avatar}
//                     <span
//                       className={`${styles.statusDot} ${styles[`status${member.status.charAt(0).toUpperCase() + member.status.slice(1)}`]}`}
//                     />
//                   </div>
//                   <div className={styles.memberInfo}>
//                     <span className={styles.memberName}>
//                       {member.name}
//                       {member.isAdmin && (
//                         <Shield
//                           size={13}
//                           className={styles.adminIcon}
//                           title="Project Admin"
//                         />
//                       )}
//                     </span>
//                     <span className={styles.memberRole}>
//                       {member.role} · {member.company}
//                     </span>
//                   </div>
//                   <span className={styles.memberDept}>{member.department}</span>
//                   <ChevronRight size={16} className={styles.chevron} />
//                 </div>
//               ))}
//           </div>
//         </div>

//         {/* Member Detail Panel */}
//         <div
//           className={`${styles.detailPanel} ${selectedMember ? styles.detailPanelOpen : ""}`}
//         >
//           {selectedMember ? (
//             <>
//               <div className={styles.detailHeader}>
//                 <button
//                   className={styles.closeBtn}
//                   onClick={() => setSelectedId(null)}
//                 >
//                   <X size={18} />
//                 </button>
//               </div>

//               <div className={styles.detailProfile}>
//                 <div className={styles.detailAvatar}>
//                   {selectedMember.avatar}
//                   <span
//                     className={`${styles.statusDotLg} ${styles[`status${selectedMember.status.charAt(0).toUpperCase() + selectedMember.status.slice(1)}`]}`}
//                   />
//                 </div>
//                 <h2 className={styles.detailName}>{selectedMember.name}</h2>
//                 <p className={styles.detailRole}>{selectedMember.role}</p>
//                 <p className={styles.detailCompany}>{selectedMember.company}</p>
//                 <span
//                   className={`${styles.statusBadge} ${styles[`badge${selectedMember.status.charAt(0).toUpperCase() + selectedMember.status.slice(1)}`]}`}
//                 >
//                   {statusLabels[selectedMember.status]}
//                 </span>
//                 {selectedMember.isAdmin && (
//                   <span className={styles.adminBadge}>
//                     <Shield size={12} /> Project Admin
//                   </span>
//                 )}
//               </div>

//               <div className={styles.detailDivider} />

//               <div className={styles.detailStats}>
//                 <div className={styles.detailStat}>
//                   <span className={styles.detailStatNum}>
//                     {selectedMember.activeProjects}
//                   </span>
//                   <span className={styles.detailStatLabel}>Ակտիվ</span>
//                 </div>
//                 <div className={styles.detailStat}>
//                   <span className={styles.detailStatNum}>
//                     {selectedMember.completedProjects}
//                   </span>
//                   <span className={styles.detailStatLabel}>Ավարտված</span>
//                 </div>
//                 <div className={styles.detailStat}>
//                   <span className={styles.detailStatNum}>
//                     {selectedMember.experience}
//                   </span>
//                   <span className={styles.detailStatLabel}>Փորձ</span>
//                 </div>
//               </div>

//               <div className={styles.detailDivider} />

//               <div className={styles.detailSection}>
//                 <h3 className={styles.detailSectionTitle}>Կապի տվյալներ</h3>
//                 <div className={styles.detailInfoList}>
//                   <div className={styles.detailInfoItem}>
//                     <Mail size={15} />
//                     <span>{selectedMember.email}</span>
//                   </div>
//                   <div className={styles.detailInfoItem}>
//                     <Phone size={15} />
//                     <span>{selectedMember.phone}</span>
//                   </div>
//                   <div className={styles.detailInfoItem}>
//                     <MapPin size={15} />
//                     <span>{selectedMember.location}</span>
//                   </div>
//                   <div className={styles.detailInfoItem}>
//                     <Building2 size={15} />
//                     <span>{selectedMember.company}</span>
//                   </div>
//                   <div className={styles.detailInfoItem}>
//                     <Calendar size={15} />
//                     <span>{selectedMember.joinDate}</span>
//                   </div>
//                 </div>
//               </div>

//               <div className={styles.detailDivider} />

//               {/* Module Access - BIM 360 style */}
//               <div className={styles.detailSection}>
//                 <div className={styles.moduleHeader}>
//                   <h3 className={styles.detailSectionTitle}>
//                     Մոդուլների հասանելիություն
//                   </h3>
//                   {!isEditingAccess ? (
//                     <button
//                       className={styles.iconBtn}
//                       onClick={startEditAccess}
//                       title="Խմբագրել"
//                     >
//                       <Pencil size={14} />
//                     </button>
//                   ) : (
//                     <div className={styles.moduleEditActions}>
//                       <button
//                         className={styles.iconBtnSuccess}
//                         onClick={saveEditAccess}
//                         title="Պահպանել"
//                       >
//                         <Check size={14} />
//                       </button>
//                       <button
//                         className={styles.iconBtn}
//                         onClick={cancelEditAccess}
//                         title="Չեղարկել"
//                       >
//                         <X size={14} />
//                       </button>
//                     </div>
//                   )}
//                 </div>

//                 <div className={styles.moduleList}>
//                   {MODULES.map((mod) => (
//                     <div key={mod.id} className={styles.moduleRow}>
//                       <span className={styles.moduleName}>{mod.label}</span>
//                       {isEditingAccess ? (
//                         <select
//                           className={styles.moduleSelect}
//                           value={editAccess[mod.id]}
//                           onChange={(e) =>
//                             setEditAccess((prev) => ({
//                               ...prev,
//                               [mod.id]: e.target.value,
//                             }))
//                           }
//                         >
//                           {ACCESS_LEVELS.map((lvl) => (
//                             <option key={lvl.value} value={lvl.value}>
//                               {lvl.label}
//                             </option>
//                           ))}
//                         </select>
//                       ) : (
//                         <span
//                           className={`${styles.accessBadge} ${styles[`access${selectedMember.moduleAccess[mod.id].charAt(0).toUpperCase() + selectedMember.moduleAccess[mod.id].slice(1)}`]}`}
//                         >
//                           {accessLabel(selectedMember.moduleAccess[mod.id])}
//                         </span>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               <div className={styles.detailDivider} />

//               <div className={styles.detailSection}>
//                 <h3 className={styles.detailSectionTitle}>Հմտություններ</h3>
//                 <div className={styles.skillTags}>
//                   {selectedMember.skills.length === 0 && (
//                     <span className={styles.noSkills}>Դեռ նշված չեն</span>
//                   )}
//                   {selectedMember.skills.map((skill, i) => (
//                     <span key={i} className={styles.skillTag}>
//                       {skill}
//                     </span>
//                   ))}
//                 </div>
//               </div>

//               <div className={styles.detailDivider} />

//               {!confirmRemove ? (
//                 <button
//                   className={styles.dangerBtn}
//                   onClick={() => setConfirmRemove(true)}
//                 >
//                   <Trash2 size={15} />
//                   Հեռացնել նախագծից
//                 </button>
//               ) : (
//                 <div className={styles.confirmBox}>
//                   <p>
//                     Վստա՞հ եք, որ ուզում եք հեռացնել {selectedMember.name}-ին
//                     նախագծից։
//                   </p>
//                   <div className={styles.confirmActions}>
//                     <button
//                       className={styles.dangerBtnSolid}
//                       onClick={removeMember}
//                     >
//                       Այո, հեռացնել
//                     </button>
//                     <button
//                       className={styles.secondaryBtn}
//                       onClick={() => setConfirmRemove(false)}
//                     >
//                       Չեղարկել
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </>
//           ) : (
//             <div className={styles.emptyDetail}>
//               <Users size={48} />
//               <p>Ընտրեք աշխատակցի մանրամասն տեղեկությունը տեսնելու համար</p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Add Member Modal */}
//       {isAddOpen && (
//         <div className={styles.modalOverlay} onClick={closeAddModal}>
//           <div
//             className={styles.modalCard}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className={styles.modalHeader}>
//               <h2 className={styles.modalTitle}>
//                 <UserPlus size={18} />
//                 Ավելացնել անդամ նախագծին
//               </h2>
//               <button className={styles.closeBtn} onClick={closeAddModal}>
//                 <X size={18} />
//               </button>
//             </div>

//             <form onSubmit={handleAddMember} className={styles.form}>
//               <div className={styles.formGroup}>
//                 <label className={styles.formLabel}>Էլ. հասցե *</label>
//                 <input
//                   type="email"
//                   className={styles.formInput}
//                   placeholder="name@company.am"
//                   value={form.email}
//                   onChange={(e) =>
//                     setForm((f) => ({ ...f, email: e.target.value }))
//                   }
//                 />
//               </div>

//               <div className={styles.formGroup}>
//                 <label className={styles.formLabel}>Անուն</label>
//                 <input
//                   type="text"
//                   className={styles.formInput}
//                   placeholder="Ոչ պարտադիր՝ մինչ հրավերի ընդունումը"
//                   value={form.name}
//                   onChange={(e) =>
//                     setForm((f) => ({ ...f, name: e.target.value }))
//                   }
//                 />
//               </div>

//               <div className={styles.formRow}>
//                 <div className={styles.formGroup}>
//                   <label className={styles.formLabel}>Ընկերություն *</label>
//                   <input
//                     type="text"
//                     className={styles.formInput}
//                     placeholder="Ընկերության անվանումը"
//                     list="company-list"
//                     value={form.company}
//                     onChange={(e) =>
//                       setForm((f) => ({ ...f, company: e.target.value }))
//                     }
//                   />
//                   <datalist id="company-list">
//                     {Array.from(new Set(members.map((m) => m.company))).map(
//                       (c) => (
//                         <option key={c} value={c} />
//                       ),
//                     )}
//                   </datalist>
//                 </div>

//                 <div className={styles.formGroup}>
//                   <label className={styles.formLabel}>Դեր</label>
//                   <select
//                     className={styles.formInput}
//                     value={form.role}
//                     onChange={(e) =>
//                       setForm((f) => ({ ...f, role: e.target.value }))
//                     }
//                   >
//                     {ROLE_OPTIONS.map((r) => (
//                       <option key={r} value={r}>
//                         {r}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               <div className={styles.formGroup}>
//                 <label className={styles.formLabel}>
//                   Մոդուլների հասանելիություն
//                 </label>
//                 <div className={styles.moduleList}>
//                   {MODULES.map((mod) => (
//                     <div key={mod.id} className={styles.moduleRow}>
//                       <span className={styles.moduleName}>{mod.label}</span>
//                       <select
//                         className={styles.moduleSelect}
//                         value={form.moduleAccess[mod.id]}
//                         onChange={(e) =>
//                           updateFormModule(mod.id, e.target.value)
//                         }
//                       >
//                         {ACCESS_LEVELS.map((lvl) => (
//                           <option key={lvl.value} value={lvl.value}>
//                             {lvl.label}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {formError && <p className={styles.formError}>{formError}</p>}

//               <div className={styles.modalActions}>
//                 <button
//                   type="button"
//                   className={styles.secondaryBtn}
//                   onClick={closeAddModal}
//                 >
//                   Չեղարկել
//                 </button>
//                 <button type="submit" className={styles.primaryBtn}>
//                   Ավելացնել նախագծին
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Dashboard;

import React, { useEffect, useState } from "react";
import {
  Mail,
  Phone,
  Building2,
  MapPin,
  Calendar,
  Users,
  X,
  ChevronRight,
  Search,
  Filter,
  UserPlus,
  Shield,
  Trash2,
  Pencil,
  Check,
} from "lucide-react";
import styles from "./Dashboard.module.css";
import { getOrganizationMembers } from "./api/index";
const MODULES = [
  { id: "docs", label: "Document Management" },
  { id: "designCollab", label: "Design Collaboration" },
  { id: "fieldMgmt", label: "Field Management" },
  { id: "modelCoord", label: "Model Coordination" },
  { id: "costMgmt", label: "Cost Management" },
];

const ACCESS_LEVELS = [
  { value: "none", label: "No access" },
  { value: "view", label: "View" },
  { value: "edit", label: "Edit" },
];

const ROLE_OPTIONS = [
  "Architect",
  "BIM Manager",
  "Project Manager",
  "Structural Engineer",
  "MEP Engineer",
  "Contractor",
  "Designer",
  "Viewer",
];

const defaultAccess = (level = "view") =>
  MODULES.reduce((acc, m) => ({ ...acc, [m.id]: level }), {});

const initialMembers = [
  {
    id: 1,
    name: "Aram Hakobyan",
    role: "Senior Architect",
    department: "Architecture",
    company: "ViewStruct",
    email: "aram@viewstruct.am",
    phone: "+374 91 123 456",
    location: "Yerevan, Armenia",
    joinDate: "2022-09-01",
    status: "online",
    avatar: "AH",
    skills: ["AutoCAD", "Revit", "BIM 360", "3ds Max"],
    activeProjects: 5,
    completedProjects: 19,
    experience: "8 years",
    isAdmin: true,
    moduleAccess: {
      docs: "edit",
      designCollab: "edit",
      fieldMgmt: "view",
      modelCoord: "edit",
      costMgmt: "view",
    },
  },
  {
    id: 2,
    name: "Anna Sargsyan",
    role: "BIM Specialist",
    department: "BIM",
    company: "ViewStruct",
    email: "anna@viewstruct.am",
    phone: "+374 93 456 789",
    location: "Yerevan, Armenia",
    joinDate: "2021-03-15",
    status: "online",
    avatar: "AS",
    skills: ["Revit", "Navisworks", "BIM 360", "Dynamo"],
    activeProjects: 3,
    completedProjects: 24,
    experience: "10 years",
    isAdmin: true,
    moduleAccess: {
      docs: "edit",
      designCollab: "edit",
      fieldMgmt: "edit",
      modelCoord: "edit",
      costMgmt: "none",
    },
  },
  {
    id: 3,
    name: "Gevorg Petrosyan",
    role: "Structural Engineer",
    department: "Structures",
    company: "ArmBuild LLC",
    email: "gevorg@armbuild.am",
    phone: "+374 94 789 012",
    location: "Gyumri, Armenia",
    joinDate: "2023-01-10",
    status: "busy",
    avatar: "GP",
    skills: ["ETABS", "SAP2000", "AutoCAD", "Tekla"],
    activeProjects: 4,
    completedProjects: 11,
    experience: "5 years",
    isAdmin: false,
    moduleAccess: {
      docs: "view",
      designCollab: "none",
      fieldMgmt: "edit",
      modelCoord: "view",
      costMgmt: "none",
    },
  },
  {
    id: 4,
    name: "Mari Adamyan",
    role: "Interior Designer",
    department: "Design",
    company: "ViewStruct",
    email: "mari@viewstruct.am",
    phone: "+374 98 345 678",
    location: "Yerevan, Armenia",
    joinDate: "2022-06-20",
    status: "offline",
    avatar: "MA",
    skills: ["3ds Max", "V-Ray", "SketchUp", "Lumion"],
    activeProjects: 2,
    completedProjects: 15,
    experience: "6 years",
    isAdmin: false,
    moduleAccess: {
      docs: "view",
      designCollab: "edit",
      fieldMgmt: "none",
      modelCoord: "none",
      costMgmt: "none",
    },
  },
  {
    id: 5,
    name: "Davit Mkrtchyan",
    role: "Mechanical Engineer",
    department: "Mechanics",
    company: "MetroDesign",
    email: "davit@metrodesign.am",
    phone: "+374 77 567 890",
    location: "Yerevan, Armenia",
    joinDate: "2020-11-05",
    status: "online",
    avatar: "DM",
    skills: ["AutoCAD MEP", "Revit MEP", "Dialux", "HydraCAD"],
    activeProjects: 6,
    completedProjects: 32,
    experience: "12 years",
    isAdmin: false,
    moduleAccess: {
      docs: "view",
      designCollab: "view",
      fieldMgmt: "edit",
      modelCoord: "edit",
      costMgmt: "view",
    },
  },
  {
    id: 6,
    name: "Lusine Vardanyan",
    role: "Project Architect",
    department: "Architecture",
    company: "ViewStruct",
    email: "lusine@viewstruct.am",
    phone: "+374 95 234 567",
    location: "Vanadzor, Armenia",
    joinDate: "2023-05-12",
    status: "online",
    avatar: "LV",
    skills: ["AutoCAD", "Civil 3D", "Revit", "Navisworks"],
    activeProjects: 3,
    completedProjects: 8,
    experience: "3 years",
    isAdmin: false,
    moduleAccess: {
      docs: "view",
      designCollab: "view",
      fieldMgmt: "none",
      modelCoord: "view",
      costMgmt: "none",
    },
  },
  {
    id: 7,
    name: "Hayk Sahakyan",
    role: "IT Specialist",
    department: "IT",
    company: "ViewStruct",
    email: "hayk@viewstruct.am",
    phone: "+374 96 890 123",
    location: "Yerevan, Armenia",
    joinDate: "2021-08-01",
    status: "busy",
    avatar: "HS",
    skills: ["Python", "JavaScript", "BIM API", "Cloud"],
    activeProjects: 4,
    completedProjects: 20,
    experience: "7 years",
    isAdmin: true,
    moduleAccess: {
      docs: "edit",
      designCollab: "view",
      fieldMgmt: "view",
      modelCoord: "view",
      costMgmt: "edit",
    },
  },
];

const statusLabels = {
  online: "Online",
  offline: "Offline",
  busy: "Busy",
  pending: "Invited",
};

const accessLabel = (value) =>
  ACCESS_LEVELS.find((a) => a.value === value)?.label ?? "No access";

const getInitials = (nameOrEmail) => {
  const base = nameOrEmail.includes("@")
    ? nameOrEmail.split("@")[0]
    : nameOrEmail;
  const parts = base.trim().split(/\s+/);
  return (
    parts
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase())
      .join("") || "??"
  );
};

const emptyForm = {
  name: "",
  email: "",
  company: "",
  role: ROLE_OPTIONS[0],
  moduleAccess: defaultAccess("view"),
};

const Dashboard = () => {
  // const [members, setMembers] = useState(initialMembers);
  const [members, setMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  const [selectedId, setSelectedId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDept, setFilterDept] = useState("all");
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [formError, setFormError] = useState("");
  const [isEditingAccess, setIsEditingAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(null);
  const [confirmRemove, setConfirmRemove] = useState(false);
  const getTextValue = (value, fallback = "—") => {
    if (typeof value === "string" || typeof value === "number") {
      return value;
    }

    if (value && typeof value === "object") {
      return value.name ?? value.title ?? value.description ?? fallback;
    }

    return fallback;
  };
  useEffect(() => {
    let isMounted = true;

    const fetchMembers = async () => {
      try {
        setIsLoading(true);
        setLoadError("");

        const response = await getOrganizationMembers((error) => {
          if (isMounted) {
            setLoadError(error.message);
          }
        });

        if (!isMounted || !response) return;

        // We support several common response structures.
        const membersData = Array.isArray(response)
          ? response
          : (response.members ??
            response.items ??
            response.results ??
            response.data);

        if (!Array.isArray(membersData)) {
          console.error("Unexpected members API response:", response);
          setLoadError("The server response format is invalid.");
          return;
        }

        setMembers(
          membersData.map((member) => {
            const name =
              member.name ||
              member.full_name ||
              member.fullName ||
              member.email?.split("@")[0] ||
              "Member";

            // return {
            //   ...member,

            //   // We adapt the API data to the UI.
            //   id: member.id ?? member.user_id ?? member.userId,
            //   name,
            //   email: member.email ?? "",
            //   role: member.role ?? member.position ?? "Member",
            //   department: member.department ?? member.role ?? "—",
            //   company: member.company ?? member.organization_name ?? "—",
            //   phone: member.phone ?? "—",
            //   location: member.location ?? "—",
            //   joinDate:
            //     member.joinDate ?? member.join_date ?? member.created_at ?? "—",
            //   status: member.status ?? "offline",
            //   avatar: getInitials(name),
            //   skills: member.skills ?? [],
            //   activeProjects: member.activeProjects ?? 0,
            //   completedProjects: member.completedProjects ?? 0,
            //   experience: member.experience ?? "—",
            //   isAdmin:
            //     member.isAdmin ??
            //     member.is_admin ??
            //     member.is_admin_of_organization ??
            //     false,

            //   // If the API does not return this data yet,
            //   // we keep safe default values for the UI.
            //   moduleAccess: {
            //     ...defaultAccess("none"),
            //     ...(member.moduleAccess ?? member.module_access ?? {}),
            //   },
            // };
            return {
              ...member,
              id: member.id ?? member.user_id ?? member.userId,
              name: getTextValue(
                member.name ??
                  member.full_name ??
                  member.fullName ??
                  member.email?.split("@")[0],
                "Member",
              ),
              email: getTextValue(member.email, ""),
              role: getTextValue(member.role ?? member.position),
              department: getTextValue(member.department),
              company: getTextValue(member.company ?? member.organization_name),
              phone: getTextValue(member.phone),
              location: getTextValue(member.location),
              joinDate: getTextValue(
                member.joinDate ?? member.join_date ?? member.created_at,
              ),
              status: getTextValue(member.status, "offline"),
              avatar: getInitials(
                getTextValue(
                  member.name ?? member.full_name ?? member.fullName,
                  "Member",
                ),
              ),
              skills: Array.isArray(member.skills) ? member.skills : [],
              activeProjects: member.activeProjects ?? 0,
              completedProjects: member.completedProjects ?? 0,
              experience: getTextValue(member.experience),
              isAdmin: member.isAdmin ?? member.is_admin ?? false,
              moduleAccess: {
                ...defaultAccess("none"),
                ...(member.moduleAccess ?? member.module_access ?? {}),
              },
            };
          }),
        );
      } catch (error) {
        if (isMounted) {
          setLoadError(
            error.response?.data?.detail ||
              error.response?.data?.message ||
              "Failed to load the organization members.",
          );
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchMembers();

    return () => {
      isMounted = false;
    };
  }, []);

  const selectedMember = members.find((m) => m.id === selectedId) || null;

  const departments = [
    "all",
    ...Array.from(new Set(members.map((m) => m.department))),
  ];

  const filtered = members.filter((m) => {
    const q = searchQuery.toLowerCase();
    const matchSearch =
      m.name.toLowerCase().includes(q) ||
      m.role.toLowerCase().includes(q) ||
      m.email.toLowerCase().includes(q);
    const matchDept = filterDept === "all" || m.department === filterDept;
    return matchSearch && matchDept;
  });

  const openAddModal = () => {
    setForm(emptyForm);
    setFormError("");
    setIsAddOpen(true);
  };

  const closeAddModal = () => setIsAddOpen(false);

  const updateFormModule = (moduleId, value) => {
    setForm((f) => ({
      ...f,
      moduleAccess: { ...f.moduleAccess, [moduleId]: value },
    }));
  };

  const handleAddMember = (e) => {
    e.preventDefault();
    if (!form.email.trim() || !form.email.includes("@")) {
      setFormError("Please enter a valid email address");
      return;
    }
    if (!form.company.trim()) {
      setFormError("Please specify the company");
      return;
    }
    const nextId = Math.max(0, ...members.map((m) => m.id)) + 1;
    const displayName = form.name.trim() || form.email.split("@")[0];
    const newMember = {
      id: nextId,
      name: displayName,
      role: form.role,
      department: form.role,
      company: form.company.trim(),
      email: form.email.trim(),
      phone: "—",
      location: "—",
      joinDate: new Date().toISOString().slice(0, 10),
      status: "pending",
      avatar: getInitials(displayName),
      skills: [],
      activeProjects: 0,
      completedProjects: 0,
      experience: "—",
      isAdmin: false,
      moduleAccess: form.moduleAccess,
    };
    setMembers((prev) => [newMember, ...prev]);
    setIsAddOpen(false);
  };

  const startEditAccess = () => {
    setEditAccess({ ...selectedMember.moduleAccess });
    setIsEditingAccess(true);
  };

  const saveEditAccess = () => {
    setMembers((prev) =>
      prev.map((m) =>
        m.id === selectedMember.id ? { ...m, moduleAccess: editAccess } : m,
      ),
    );
    setIsEditingAccess(false);
  };

  const cancelEditAccess = () => setIsEditingAccess(false);

  const removeMember = () => {
    setMembers((prev) => prev.filter((m) => m.id !== selectedMember.id));
    setSelectedId(null);
    setConfirmRemove(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {/* Team List */}
        <div className={styles.listCard}>
          <div className={styles.listHeader}>
            <div className={styles.listHeaderLeft}>
              <h2 className={styles.listTitle}>
                <Users size={20} />
                Members
              </h2>
              <span className={styles.listCount}>{filtered.length}</span>
            </div>
            <div className={styles.toolbar}>
              <div className={styles.searchBox}>
                <Search size={16} />
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className={styles.searchInput}
                />
              </div>
              <div className={styles.filterBox}>
                <Filter size={14} />
                <select
                  value={filterDept}
                  onChange={(e) => setFilterDept(e.target.value)}
                  className={styles.filterSelect}
                >
                  {departments.map((d) => (
                    <option key={d} value={d}>
                      {d === "all" ? "All" : d}
                    </option>
                  ))}
                </select>
              </div>
              {/* <button className={styles.addBtn} onClick={openAddModal}>
                <UserPlus size={16} />
                Add member
              </button> */}
            </div>
          </div>

          <div className={styles.teamList}>
            {isLoading && (
              <div className={styles.emptyList}>Loading members...</div>
            )}
            {!isLoading && loadError && (
              <div className={styles.emptyList}>{loadError}</div>
            )}
            {!isLoading && !loadError && filtered.length === 0 && (
              <div className={styles.emptyList}>No members found</div>
            )}

            {!isLoading &&
              !loadError &&
              filtered.map((member) => (
                <div
                  key={member.id}
                  className={`${styles.memberRow} ${selectedId === member.id ? styles.memberRowActive : ""}`}
                  onClick={() => {
                    setSelectedId(member.id);
                    setIsEditingAccess(false);
                    setConfirmRemove(false);
                  }}
                >
                  <div className={styles.memberAvatar}>
                    {member.avatar}
                    <span
                      className={`${styles.statusDot} ${styles[`status${member.status.charAt(0).toUpperCase() + member.status.slice(1)}`]}`}
                    />
                  </div>
                  <div className={styles.memberInfo}>
                    <span className={styles.memberName}>
                      {member.name}
                      {member.isAdmin && (
                        <Shield
                          size={13}
                          className={styles.adminIcon}
                          title="Project Admin"
                        />
                      )}
                    </span>
                    <span className={styles.memberRole}>
                      {member.role} · {member.company}
                    </span>
                  </div>
                  <span className={styles.memberDept}>{member.department}</span>
                  <ChevronRight size={16} className={styles.chevron} />
                </div>
              ))}
          </div>
        </div>

        {/* Member Detail Panel */}
        <div
          className={`${styles.detailPanel} ${selectedMember ? styles.detailPanelOpen : ""}`}
        >
          {selectedMember ? (
            <>
              <div className={styles.detailHeader}>
                <button
                  className={styles.closeBtn}
                  onClick={() => setSelectedId(null)}
                >
                  <X size={18} />
                </button>
              </div>

              <div className={styles.detailProfile}>
                <div className={styles.detailAvatar}>
                  {selectedMember.avatar}
                  <span
                    className={`${styles.statusDotLg} ${styles[`status${selectedMember.status.charAt(0).toUpperCase() + selectedMember.status.slice(1)}`]}`}
                  />
                </div>
                <h2 className={styles.detailName}>{selectedMember.name}</h2>
                <p className={styles.detailRole}>{selectedMember.role}</p>
                <p className={styles.detailCompany}>{selectedMember.company}</p>
                <span
                  className={`${styles.statusBadge} ${styles[`badge${selectedMember.status.charAt(0).toUpperCase() + selectedMember.status.slice(1)}`]}`}
                >
                  {statusLabels[selectedMember.status]}
                </span>
                {selectedMember.isAdmin && (
                  <span className={styles.adminBadge}>
                    <Shield size={12} /> Project Admin
                  </span>
                )}
              </div>

              <div className={styles.detailDivider} />

              <div className={styles.detailStats}>
                <div className={styles.detailStat}>
                  <span className={styles.detailStatNum}>
                    {selectedMember.activeProjects}
                  </span>
                  <span className={styles.detailStatLabel}>Active</span>
                </div>
                <div className={styles.detailStat}>
                  <span className={styles.detailStatNum}>
                    {selectedMember.completedProjects}
                  </span>
                  <span className={styles.detailStatLabel}>Completed</span>
                </div>
                <div className={styles.detailStat}>
                  <span className={styles.detailStatNum}>
                    {selectedMember.experience}
                  </span>
                  <span className={styles.detailStatLabel}>Experience</span>
                </div>
              </div>

              <div className={styles.detailDivider} />

              <div className={styles.detailSection}>
                <h3 className={styles.detailSectionTitle}>Contact details</h3>
                <div className={styles.detailInfoList}>
                  <div className={styles.detailInfoItem}>
                    <Mail size={15} />
                    <span>{selectedMember.email}</span>
                  </div>
                  <div className={styles.detailInfoItem}>
                    <Phone size={15} />
                    <span>{selectedMember.phone}</span>
                  </div>
                  <div className={styles.detailInfoItem}>
                    <MapPin size={15} />
                    <span>{selectedMember.location}</span>
                  </div>
                  <div className={styles.detailInfoItem}>
                    <Building2 size={15} />
                    <span>{selectedMember.company}</span>
                  </div>
                  <div className={styles.detailInfoItem}>
                    <Calendar size={15} />
                    <span>{selectedMember.joinDate}</span>
                  </div>
                </div>
              </div>

              <div className={styles.detailDivider} />

              {/* Module Access - BIM 360 style */}
              <div className={styles.detailSection}>
                <div className={styles.moduleHeader}>
                  <h3 className={styles.detailSectionTitle}>Module access</h3>
                  {!isEditingAccess ? (
                    <button
                      className={styles.iconBtn}
                      onClick={startEditAccess}
                      title="Edit"
                    >
                      <Pencil size={14} />
                    </button>
                  ) : (
                    <div className={styles.moduleEditActions}>
                      <button
                        className={styles.iconBtnSuccess}
                        onClick={saveEditAccess}
                        title="Save"
                      >
                        <Check size={14} />
                      </button>
                      <button
                        className={styles.iconBtn}
                        onClick={cancelEditAccess}
                        title="Cancel"
                      >
                        <X size={14} />
                      </button>
                    </div>
                  )}
                </div>

                <div className={styles.moduleList}>
                  {MODULES.map((mod) => (
                    <div key={mod.id} className={styles.moduleRow}>
                      <span className={styles.moduleName}>{mod.label}</span>
                      {isEditingAccess ? (
                        <select
                          className={styles.moduleSelect}
                          value={editAccess[mod.id]}
                          onChange={(e) =>
                            setEditAccess((prev) => ({
                              ...prev,
                              [mod.id]: e.target.value,
                            }))
                          }
                        >
                          {ACCESS_LEVELS.map((lvl) => (
                            <option key={lvl.value} value={lvl.value}>
                              {lvl.label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span
                          className={`${styles.accessBadge} ${styles[`access${selectedMember.moduleAccess[mod.id].charAt(0).toUpperCase() + selectedMember.moduleAccess[mod.id].slice(1)}`]}`}
                        >
                          {accessLabel(selectedMember.moduleAccess[mod.id])}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div className={styles.detailDivider} />

              <div className={styles.detailSection}>
                <h3 className={styles.detailSectionTitle}>Skills</h3>
                <div className={styles.skillTags}>
                  {selectedMember.skills.length === 0 && (
                    <span className={styles.noSkills}>Not specified yet</span>
                  )}
                  {selectedMember.skills.map((skill, i) => (
                    <span key={i} className={styles.skillTag}>
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              <div className={styles.detailDivider} />

              {!confirmRemove ? (
                <button
                  className={styles.dangerBtn}
                  onClick={() => setConfirmRemove(true)}
                >
                  <Trash2 size={15} />
                  Remove from project
                </button>
              ) : (
                <div className={styles.confirmBox}>
                  <p>
                    Are you sure you want to remove {selectedMember.name} from
                    the project?
                  </p>
                  <div className={styles.confirmActions}>
                    <button
                      className={styles.dangerBtnSolid}
                      onClick={removeMember}
                    >
                      Yes, remove
                    </button>
                    <button
                      className={styles.secondaryBtn}
                      onClick={() => setConfirmRemove(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className={styles.emptyDetail}>
              <Users size={48} />
              <p>Select a team member to see detailed information</p>
            </div>
          )}
        </div>
      </div>

      {/* Add Member Modal */}
      {isAddOpen && (
        <div className={styles.modalOverlay} onClick={closeAddModal}>
          <div
            className={styles.modalCard}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.modalHeader}>
              <h2 className={styles.modalTitle}>
                <UserPlus size={18} />
                Add member to project
              </h2>
              <button className={styles.closeBtn} onClick={closeAddModal}>
                <X size={18} />
              </button>
            </div>

            <form onSubmit={handleAddMember} className={styles.form}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Email *</label>
                <input
                  type="email"
                  className={styles.formInput}
                  placeholder="name@company.am"
                  value={form.email}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, email: e.target.value }))
                  }
                />
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Name</label>
                <input
                  type="text"
                  className={styles.formInput}
                  placeholder="Optional until the invitation is accepted"
                  value={form.name}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, name: e.target.value }))
                  }
                />
              </div>

              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>Company *</label>
                  <input
                    type="text"
                    className={styles.formInput}
                    placeholder="Company name"
                    list="company-list"
                    value={form.company}
                    onChange={(e) =>
                      setForm((f) => ({ ...f, company: e.target.value }))
                    }
                  />
                  <datalist id="company-list">
                    {Array.from(new Set(members.map((m) => m.company))).map(
                      (c) => (
                        <option key={c} value={c} />
                      ),
                    )}
                  </datalist>
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>Role</label>
                  <select
                    className={styles.formInput}
                    value={form.role}
                    onChange={(e) =>
                      setForm((f) => ({ ...f, role: e.target.value }))
                    }
                  >
                    {ROLE_OPTIONS.map((r) => (
                      <option key={r} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Module access</label>
                <div className={styles.moduleList}>
                  {MODULES.map((mod) => (
                    <div key={mod.id} className={styles.moduleRow}>
                      <span className={styles.moduleName}>{mod.label}</span>
                      <select
                        className={styles.moduleSelect}
                        value={form.moduleAccess[mod.id]}
                        onChange={(e) =>
                          updateFormModule(mod.id, e.target.value)
                        }
                      >
                        {ACCESS_LEVELS.map((lvl) => (
                          <option key={lvl.value} value={lvl.value}>
                            {lvl.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  ))}
                </div>
              </div>

              {formError && <p className={styles.formError}>{formError}</p>}

              <div className={styles.modalActions}>
                <button
                  type="button"
                  className={styles.secondaryBtn}
                  onClick={closeAddModal}
                >
                  Cancel
                </button>
                <button type="submit" className={styles.primaryBtn}>
                  Add to project
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
